import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const ShippingPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom fontWeight={700}>Shipping Policy</Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Our goal is to deliver your custom products safely and on time.
      </Typography>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Processing & Production</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Orders enter production after payment confirmation and required assets (images/text) are provided. Production times vary by product type, typically 2–5 business days.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Shipping Timeline</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Average transit time: 3–7 business days depending on destination. Remote areas may take longer.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Tracking</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Tracking details are shared once the order is shipped. Delays from the courier network are outside our direct control, but we will assist where possible.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Shipping Fees</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Fees are calculated at checkout based on selected shipping option and any free shipping thresholds.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Non-Delivery / Address Issues</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Please ensure your address and contact details are accurate. Re-delivery costs due to incorrect address may be chargeable.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Damage During Transit</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Inspect the package at delivery. If damaged, record photos/video and contact us within 48 hours. See Returns & Exchange Policy for exchange eligibility.
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="h5" gutterBottom>Contact</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          For shipping questions, contact info@therandomstore.com.
        </Typography>
      </Box>
    </Container>
  );
};

export default ShippingPolicy;
